import * as action_types from "./constants";
import { CrewFormType, CrewYardTableType, GetCrewYardType } from "./types";

export type crewYardState = {
  crewYardData: {
    loader: boolean;
    data: CrewYardTableType[] | null;
    count: number;
  };
  crewYardDetailData?: {
    data: GetCrewYardType | null;
    loader: boolean;
  };
  crewYardFormData: {
    data: CrewFormType | null;
    loader: boolean;
  };
};

const initialState: crewYardState = {
  crewYardData: {
    loader: true,
    data: null,
    count: 0,
  },
  crewYardDetailData: {
    data: null,
    loader: true,
  },
  crewYardFormData: {
    data: null,
    loader: true,
  },
};

type MyDataActionType =
  | {
      type: typeof action_types.CREW_YARD_LISTING;
      data: { payload: CrewYardTableType[]; loading: boolean; count: number };
    }
  | {
      type: typeof action_types.CREW_YARD_DETAIL_DATA;
      data: { payload: GetCrewYardType; loading: boolean };
    }
  | {
      type: typeof action_types.CREW_YARD_FORM_DATA;
      data: { payload: CrewFormType; loading: boolean };
    };

const myTeamReducer = (
  state = initialState,
  action: MyDataActionType
): crewYardState => {
  const { type, data } = action;
  switch (type) {
    case action_types.CREW_YARD_LISTING:
      return {
        ...state,
        crewYardData: {
          loader: data?.loading || false,
          data: data?.payload,
          count: data?.count,
        },
      };

    case action_types.CREW_YARD_DETAIL_DATA:
      return {
        ...state,
        crewYardDetailData: { data: data?.payload, loader: data?.loading },
      };

    case action_types.CREW_YARD_FORM_DATA:
      return {
        ...state,
        crewYardFormData: { data: data?.payload, loader: data?.loading },
      };

    default:
      return state;
  }
};

export default myTeamReducer;
